<template>
  <div class="footer-social">
    <div class="container flex justify-between">
      <a v-for="icon in icons" :href="icon.url">
        <img
          :src="require('../../assets/images/social/' + icon.name + '.svg')"
          :alt="icon.name"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FooterSocial',
    data () {
        return {
            icons: [
                { name: 'facebook', url: 'https://www.facebook.com/uni.hamburg' },
                { name: 'twitter', url: 'https://twitter.com/unihh' },
                { name: 'instagram', url: 'https://instagram.com/uni_hamburg' },
                { name: 'youtube', url: 'https://www.youtube.com/c/unihamburg' },
                { name: 'lecture2go', url: 'https://lecture2go.uni-hamburg.de/' },
            ],
        };
    },
};
</script>

<style scoped>
.footer-social {
  padding: 46px 20px;
  background: #f3f3f3;
  min-height: 72px;
  display: flex;
  justify-content: space-between;
}

.footer-social img {
  user-select: none;
}
</style>
